import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import { BloqueFirmasPdf } from "../Components/PdfComponents/BloqueFirmasPdf";

moment.locale("es");

const TIPOS_MOVIMIENTO = {
  101: "Entrada por compra",
  102: "Reversa entrada",
  103: "Entrada por cambio de insumo",
  201: "Salida a centro de costos",
  261: "Consumo a producción",
  301: "Transferencia entre almacenes",
  311: "Cambio ubicación",
  601: "Salida por venta",
  602: "Salida por cambio de insumo",
  651: "Salida devolución",
  701: "Ajuste positivo inventario",
  702: "Ajuste negativo inventario",
};

const movimientoInventarioPdf = (data, opciones = {}) => {
  const { movimiento, empresa } = data;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const mostrarCostos = !!opciones.mostrarCostos;

  const layoutTabla = {
    hLineWidth: () => 1,
    vLineWidth: () => 1,
    hLineColor: () => "#e8e8e8",
    vLineColor: () => "#e8e8e8",
    fillColor: (rowIndex) => (rowIndex === 0 ? null : rowIndex % 2 === 0 ? "#f9f9f9" : null),
  };

  const estiloHeaderTabla = {
    bold: true,
    fontSize: 9,
    color: "black",
    fillColor: "#dedede",
    margin: [4, 4, 4, 4],
  };

  const estiloCelda = {
    fontSize: 9,
    margin: [4, 4, 4, 4],
  };

  const tieneLotes = (movimiento.insumos || []).some(
    (i) => i.lote || i.numero || i.caducidad || i.numeroMarbete
  );
  // const tieneTrazabilidad = (movimiento.insumos || []).some(
  //   (i) => Array.isArray(i.trazabilidad) && i.trazabilidad.length > 0
  // );

  // Cabecera de la tabla de insumos
  let widthsInsumos;
  let headersInsumos;
  if (tieneLotes && mostrarCostos) {
    widthsInsumos = ["8%", "22%", "13%", "9%", "7%", "10%", "10%", "11%", "10%"];
    headersInsumos = [
      { text: "Clave", style: estiloHeaderTabla },
      { text: "Descripción", style: estiloHeaderTabla },
      { text: "Proyecto", style: estiloHeaderTabla },
      { text: "Cantidad", style: estiloHeaderTabla, alignment: "right" },
      { text: "Unidad", style: estiloHeaderTabla, alignment: "center" },
      { text: "Costo U.", style: estiloHeaderTabla, alignment: "right" },
      { text: "Costo Tot.", style: estiloHeaderTabla, alignment: "right" },
      { text: "Lote", style: estiloHeaderTabla, alignment: "center" },
      { text: "Caducidad", style: estiloHeaderTabla, alignment: "center" },
    ];
  } else if (tieneLotes && !mostrarCostos) {
    widthsInsumos = ["10%", "28%", "16%", "11%", "9%", "13%", "13%"];
    headersInsumos = [
      { text: "Clave", style: estiloHeaderTabla },
      { text: "Descripción", style: estiloHeaderTabla },
      { text: "Proyecto", style: estiloHeaderTabla },
      { text: "Cantidad", style: estiloHeaderTabla, alignment: "right" },
      { text: "Unidad", style: estiloHeaderTabla, alignment: "center" },
      { text: "Lote", style: estiloHeaderTabla, alignment: "center" },
      { text: "Caducidad", style: estiloHeaderTabla, alignment: "center" },
    ];
  } else if (!tieneLotes && mostrarCostos) {
    widthsInsumos = ["10%", "30%", "16%", "10%", "10%", "12%", "12%"];
    headersInsumos = [
      { text: "Clave", style: estiloHeaderTabla },
      { text: "Descripción", style: estiloHeaderTabla },
      { text: "Proyecto", style: estiloHeaderTabla },
      { text: "Cantidad", style: estiloHeaderTabla, alignment: "right" },
      { text: "Unidad", style: estiloHeaderTabla, alignment: "center" },
      { text: "Costo U.", style: estiloHeaderTabla, alignment: "right" },
      { text: "Costo Tot.", style: estiloHeaderTabla, alignment: "right" },
    ];
  } else {
    widthsInsumos = ["12%", "40%", "20%", "14%", "14%"];
    headersInsumos = [
      { text: "Clave", style: estiloHeaderTabla },
      { text: "Descripción", style: estiloHeaderTabla },
      { text: "Proyecto", style: estiloHeaderTabla },
      { text: "Cantidad", style: estiloHeaderTabla, alignment: "right" },
      { text: "Unidad", style: estiloHeaderTabla, alignment: "center" },
    ];
  }
  const numColsInsumos = headersInsumos.length;

  const bodyInsumos = [headersInsumos];

  (movimiento.insumos || []).forEach((item) => {
    const ins = item.insumo || {};
    const clave = ins.clave || ins.codigo || "-";
    const descripcion = ins.descripcion || "-";
    const proyectoNombre =
      item.proyecto?.nombre ||
      item.proyectoId?.nombre ||
      item.proyectoNombre ||
      "-";
    const unidad = ins.unidad?.nombre || ins.unidadNombre || "-";
    const cantidad = Number(item.cantidad) || 0;
    const costoU = Number(item.costoUnitario) || 0;
    const costoT =
      item.costoTotal !== undefined && item.costoTotal !== null
        ? Number(item.costoTotal)
        : costoU * cantidad;
    const fila = [
      { text: clave, style: estiloCelda },
      { text: descripcion, style: estiloCelda },
      { text: proyectoNombre, style: estiloCelda },
      { text: cantidad.toFixed(4), style: estiloCelda, alignment: "right" },
      { text: unidad, style: estiloCelda, alignment: "center" },
    ];
    if (mostrarCostos) {
      fila.push({ text: dineroDisabledMask(costoU), style: estiloCelda, alignment: "right" });
      fila.push({ text: dineroDisabledMask(costoT), style: estiloCelda, alignment: "right" });
    }
    if (tieneLotes) {
      fila.push({
        text: item.lote || item.numero || item.numeroMarbete || "-",
        style: estiloCelda,
        alignment: "center",
      });
      fila.push({
        text: item.caducidad ? moment(item.caducidad).format("DD/MM/YYYY") : "-",
        style: estiloCelda,
        alignment: "center",
      });
    }
    bodyInsumos.push(fila);
  });

  if (bodyInsumos.length === 1) {
    bodyInsumos.push([
      {
        text: "No hay insumos en este movimiento",
        style: estiloCelda,
        colSpan: numColsInsumos,
        alignment: "center",
      },
      ...Array(numColsInsumos - 1).fill({}),
    ]);
  }

  // Bloque de cabecera (datos del movimiento)
  const tipoTexto =
    movimiento.descripcionTipoMovimiento ||
    TIPOS_MOVIMIENTO[movimiento.tipoMovimiento] ||
    "-";
  const tipoLinea = `(${movimiento.tipoMovimiento}) ${tipoTexto}`;

  const documentoOrigen =
    movimiento.documentoOrigenTipo
      ? `${movimiento.documentoOrigenTipo}${
          movimiento.documentoOrigenSerieFolio ? " " + movimiento.documentoOrigenSerieFolio : ""
        }`
      : "-";

  let contraparteLabel = null;
  let contraparteValor = null;
  if (movimiento.cliente?.nombre || movimiento.cliente?.razonSocial) {
    contraparteLabel = "Cliente";
    contraparteValor = movimiento.cliente.razonSocial
      ? movimiento.cliente.razonSocial
      : `${movimiento.cliente.nombre || ""} ${movimiento.cliente.apellidoPaterno || ""} ${movimiento.cliente.apellidoMaterno || ""}`.trim();
  } else if (movimiento.proveedor?.nombre || movimiento.proveedor?.razonSocial) {
    contraparteLabel = "Proveedor";
    contraparteValor = movimiento.proveedor.razonSocial
      ? movimiento.proveedor.razonSocial
      : `${movimiento.proveedor.nombre || ""} ${movimiento.proveedor.apellidoPaterno || ""} ${movimiento.proveedor.apellidoMaterno || ""}`.trim();
  }

  const filasCabecera = [
    [
      { text: "Tipo Movimiento", style: estiloHeaderTabla },
      { text: tipoLinea, style: estiloCelda },
      { text: "E/S", style: estiloHeaderTabla },
      { text: movimiento.esSalida ? "Salida" : "Entrada", style: estiloCelda },
    ],
    [
      { text: "Doc. Origen", style: estiloHeaderTabla },
      { text: documentoOrigen, style: estiloCelda, colSpan: 3 },
      {},
      {},
    ],
  ];

  if (contraparteLabel) {
    filasCabecera.push([
      { text: contraparteLabel, style: estiloHeaderTabla },
      { text: contraparteValor || "-", style: estiloCelda, colSpan: 3 },
      {},
      {},
    ]);
  }

  if (movimiento.referencia || movimiento.concepto) {
    filasCabecera.push([
      { text: "Concepto", style: estiloHeaderTabla },
      { text: movimiento.concepto || "-", style: estiloCelda },
      { text: "Referencia", style: estiloHeaderTabla },
      { text: movimiento.referencia || "-", style: estiloCelda },
    ]);
  }

  if (movimiento.observaciones) {
    filasCabecera.push([
      { text: "Observaciones", style: estiloHeaderTabla },
      { text: movimiento.observaciones, style: estiloCelda, colSpan: 3 },
      {},
      {},
    ]);
  }

  if (movimiento.usuario) {
    const u = movimiento.usuario;
    const nombreU = u.nombre
      ? `${u.nombre} ${u.apellidoPaterno || ""} ${u.apellidoMaterno || ""}`.trim()
      : u.correo || "-";
    filasCabecera.push([
      { text: "Capturó", style: estiloHeaderTabla },
      { text: nombreU, style: estiloCelda },
      { text: "Creado", style: estiloHeaderTabla },
      {
        text: movimiento.createdAt
          ? moment(movimiento.createdAt).format("DD/MM/YYYY HH:mm")
          : "-",
        style: estiloCelda,
      },
    ]);
  }

  // Cancelación
  if (movimiento.estado === 0 && movimiento.cancelacion) {
    const c = movimiento.cancelacion;
    const usrC = c.usuario
      ? `${c.usuario.nombre || ""} ${c.usuario.apellidoPaterno || ""}`.trim()
      : "-";
    filasCabecera.push([
      { text: "Cancelado por", style: estiloHeaderTabla },
      { text: usrC, style: estiloCelda },
      { text: "Fecha cancel.", style: estiloHeaderTabla },
      {
        text: c.fecha ? moment(c.fecha).format("DD/MM/YYYY HH:mm") : "-",
        style: estiloCelda,
      },
    ]);
    if (c.motivo) {
      filasCabecera.push([
        { text: "Motivo", style: estiloHeaderTabla },
        { text: c.motivo, style: estiloCelda, colSpan: 3 },
        {},
        {},
      ]);
    }
  }

  // Trazabilidad (capas afectadas) — opcional, sólo si hay.
  // Comentado a propósito: por ahora no se debe mostrar en el PDF. Dejar el
  // bloque completo comentado (no borrado) para poder reactivarlo después
  // solo descomentando.
  let bloqueTraza = null;
  // if (tieneTrazabilidad) {
  //   const headersTraza = mostrarCostos
  //     ? [
  //         { text: "Insumo", style: estiloHeaderTabla },
  //         { text: "Lote / Marbete", style: estiloHeaderTabla, alignment: "center" },
  //         { text: "Caducidad", style: estiloHeaderTabla, alignment: "center" },
  //         { text: "Cantidad", style: estiloHeaderTabla, alignment: "right" },
  //         { text: "Costo U.", style: estiloHeaderTabla, alignment: "right" },
  //       ]
  //     : [
  //         { text: "Insumo", style: estiloHeaderTabla },
  //         { text: "Lote / Marbete", style: estiloHeaderTabla, alignment: "center" },
  //         { text: "Caducidad", style: estiloHeaderTabla, alignment: "center" },
  //         { text: "Cantidad", style: estiloHeaderTabla, alignment: "right" },
  //       ];
  //   const bodyTraza = [headersTraza];
  //   (movimiento.insumos || []).forEach((item) => {
  //     if (!Array.isArray(item.trazabilidad) || item.trazabilidad.length === 0) return;
  //     const ins = item.insumo || {};
  //     const claveDesc = `${ins.clave || ins.codigo || ""}${
  //       ins.descripcion ? " - " + ins.descripcion : ""
  //     }`;
  //     item.trazabilidad.forEach((t) => {
  //       const filaTraza = [
  //         { text: claveDesc, style: estiloCelda },
  //         {
  //           text: t.lote || [t.numeroMarbete, t.numero2Marbete].filter(Boolean).join(" / ") || "-",
  //           style: estiloCelda,
  //           alignment: "center",
  //         },
  //         {
  //           text: t.caducidad ? moment(t.caducidad).format("DD/MM/YYYY") : "-",
  //           style: estiloCelda,
  //           alignment: "center",
  //         },
  //         {
  //           text: (Number(t.cantidad) || 0).toFixed(4),
  //           style: estiloCelda,
  //           alignment: "right",
  //         },
  //       ];
  //       if (mostrarCostos) {
  //         filaTraza.push({
  //           text: dineroDisabledMask(t.costoU || 0),
  //           style: estiloCelda,
  //           alignment: "right",
  //         });
  //       }
  //       bodyTraza.push(filaTraza);
  //     });
  //   });
  //   bloqueTraza = [
  //     {
  //       text: "Trazabilidad (capas afectadas)",
  //       style: "tableHeaderIzquierda",
  //       margin: [0, 10, 0, 5],
  //     },
  //     {
  //       table: {
  //         widths: mostrarCostos
  //           ? ["35%", "20%", "15%", "15%", "15%"]
  //           : ["40%", "25%", "20%", "15%"],
  //         body: bodyTraza,
  //       },
  //       layout: layoutTabla,
  //       margin: [0, 0, 0, 10],
  //     },
  //   ];
  // }

  const folioTexto = `${movimiento.serie ? movimiento.serie + " - " : ""}${movimiento.folio || ""}` || movimiento.serieNumero || "-";
  const folioTipoTexto =
    movimiento.serieTipo || movimiento.folioTipo
      ? `${movimiento.serieTipo ? movimiento.serieTipo + " - " : ""}${movimiento.folioTipo || ""}`
      : null;

  const dd = {
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["20%", "50%", "30%"],
          layout: "noBorders",
          body: [
            [
              ...HeaderEmpresaCard(empresa, mostrarRegimen, false, {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Folio:", style: "subheader", alignment: "center" }],
                    [{ text: folioTipoTexto || folioTexto, style: "textoChico", alignment: "center" }],
                    [{ text: "Fecha:", style: "subheader", alignment: "center" }],
                    [
                      {
                        text: movimiento.fecha
                          ? moment(movimiento.fecha).format("DD/MM/YYYY HH:mm")
                          : "-",
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },

      {
        stack: [
          {
            text: `Movimiento de Inventario  ${folioTipoTexto || folioTexto}`,
            style: "tituloPrincipal",
            alignment: "left",
          },
          ...(folioTipoTexto
            ? [
                {
                  text: `General: ${folioTexto}`,
                  fontSize: 8,
                  color: "#888888",
                  alignment: "left",
                  margin: [0, 1, 0, 0],
                },
              ]
            : []),
        ],
        margin: [0, 5, 0, 10],
      },

      {
        style: "tableExample",
        margin: [0, 0, 0, 12],
        table: {
          widths: ["18%", "32%", "18%", "32%"],
          body: filasCabecera,
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#bdbdbd",
          vLineColor: () => "#bdbdbd",
        },
      },

      { text: "Detalle de Insumos", style: "tableHeaderIzquierda", margin: [0, 0, 0, 5] },
      {
        table: {
          widths: widthsInsumos,
          body: bodyInsumos,
        },
        layout: layoutTabla,
        margin: [0, 0, 0, 10],
      },

      {
        style: "tableExample",
        margin: [0, 0, 0, 0],
        table: {
          widths: ["60%", "20%", "20%"],
          body: [
            [
              { text: "", border: [false, false, false, false] },
              {
                text: "Cantidad Total",
                style: estiloHeaderTabla,
                alignment: "right",
              },
              {
                text: (Number(movimiento.cantidadTotal) || 0).toFixed(4),
                style: estiloCelda,
                alignment: "right",
              },
            ],
            ...(mostrarCostos
              ? [
                  [
                    { text: "", border: [false, false, false, false] },
                    {
                      text: "Costo Total",
                      style: estiloHeaderTabla,
                      alignment: "right",
                    },
                    {
                      text: dineroDisabledMask(Number(movimiento.costoTotal) || 0),
                      style: estiloCelda,
                      alignment: "right",
                    },
                  ],
                ]
              : []),
          ],
        },
      },

      ...(bloqueTraza || []),

      ...(movimiento.movimientoRelacionado
        ? [
            {
              text: `Movimiento relacionado: ${
                movimiento.movimientoRelacionado.serieNumero ||
                movimiento.movimientoRelacionado.folio ||
                ""
              }`,
              style: "textoChico",
              margin: [0, 15, 0, 0],
            },
          ]
        : []),

      BloqueFirmasPdf([{ titulo: "Entrega" }, { titulo: "Recibe" }]),
    ],

    images: {
      logo: empresa?.logo?.base64Completa ? empresa.logo.base64Completa : "",
    },
    styles: {
      tituloPrincipal: { fontSize: 16, bold: true, color: "black" },
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 0, 0, 0] },
      tableHeaderIzquierda: { bold: true, fontSize: 13, color: "black" },
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico: { fontSize: 8 },
    },
    pageSize: "LETTER",
    pageMargins: [40, 40, 40, 40],
  };

  if (movimiento.estado === 0) {
    dd.watermark = {
      text: "CANCELADO",
      color: "gray",
      opacity: 0.2,
      bold: true,
      italics: false,
      angle: 45,
    };
  }

  return dd;
};

export default movimientoInventarioPdf;
